__webpack_require__.p = "/aitool-static/_next/";